/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { TreeView } from '@neo4j-ndl/react';
import { PencilIconOutline } from '@neo4j-ndl/react/icons';
import type React from 'react';
import { useState } from 'react';

const TREE_ITEMS: React.ComponentProps<typeof TreeView>['items'] = [
  {
    canHaveSubItems: true,
    data: {
      actions: [
        {
          buttonProps: {
            description: 'Edit',
            onClick: () => {
              alert('Pencil was clicked');
            },
          },
          icon: <PencilIconOutline />,
        },
      ],
      onTextClick: () => {
        alert('Text was clicked');
      },
      text: 'Folder 1',
    },
    id: 'Folder 1',
    isCollapsed: false,
    isSelected: false,
    isSortable: false,
    subItems: [
      {
        canHaveSubItems: false,
        data: {
          actions: [
            {
              buttonProps: {
                description: 'Edit',
                onClick: () => {
                  alert('Pencil was clicked');
                },
              },
              icon: <PencilIconOutline />,
            },
          ],
          onTextClick: () => {
            alert('Text was clicked');
          },
          text: 'Child 1',
        },
        id: 'Child 1',
        isSelected: false,
        isSortable: true,
      },
      {
        canHaveSubItems: false,
        data: {
          actions: [
            {
              buttonProps: {
                description: 'Edit',
                onClick: () => {
                  alert('Pencil was clicked');
                },
              },
              icon: <PencilIconOutline />,
            },
          ],
          onTextClick: () => {
            alert('Text was clicked');
          },
          text: 'Child 2',
        },
        id: 'Child 2',
        isSelected: false,
        isSortable: true,
      },
      {
        canHaveSubItems: false,
        data: {
          actions: [
            {
              buttonProps: {
                description: 'Edit',
                onClick: () => {
                  alert('Pencil was clicked');
                },
              },
              icon: <PencilIconOutline />,
            },
          ],
          onTextClick: () => {
            alert('Text was clicked');
          },
          text: 'Child 3',
        },
        id: 'Child 3',
        isSelected: false,
        isSortable: true,
      },
      {
        canHaveSubItems: true,
        data: {
          actions: [
            {
              buttonProps: {
                description: 'Edit',
                onClick: () => {
                  alert('Pencil was clicked');
                },
              },
              icon: <PencilIconOutline />,
            },
          ],
          onTextClick: () => {
            alert('Text was clicked');
          },
          text: 'Folder 2',
        },
        id: 'Folder 2',
        isCollapsed: true,
        isSelected: false,
        isSortable: true,
        subItems: [
          {
            canHaveSubItems: false,
            data: {
              actions: [
                {
                  buttonProps: {
                    description: 'Edit',
                    onClick: () => {
                      alert('Pencil was clicked');
                    },
                  },
                  icon: <PencilIconOutline />,
                },
              ],
              onTextClick: () => {
                alert('Text was clicked');
              },
              text: 'Child 4',
            },

            id: 'Child 4',
            isSelected: false,
          },
          {
            canHaveSubItems: false,
            data: {
              actions: [
                {
                  buttonProps: {
                    description: 'Edit',
                    onClick: () => {
                      alert('Pencil was clicked');
                    },
                  },
                  icon: <PencilIconOutline />,
                },
              ],
              onTextClick: () => {
                alert('Text was clicked');
              },
              text: 'Child 5',
            },
            id: 'Child 5',
            isSelected: false,
          },
          {
            canHaveSubItems: false,
            data: {
              actions: [
                {
                  buttonProps: {
                    description: 'Edit',
                    onClick: () => {
                      alert('Pencil was clicked');
                    },
                  },
                  icon: <PencilIconOutline />,
                },
              ],
              onTextClick: () => {
                alert('Text was clicked');
              },
              text: 'Child 6',
            },
            id: 'Child 6',
            isSelected: false,
          },
        ],
      },
    ],
  },
  {
    canHaveSubItems: false,
    data: {
      actions: [
        {
          buttonProps: {
            description: 'Edit',
            onClick: () => {
              alert('Pencil was clicked');
            },
          },
          icon: <PencilIconOutline />,
        },
      ],
      onTextClick: () => {
        alert('Text was clicked');
      },
      text: 'Child 7',
    },
    id: 'Child 7',
    isSelected: false,
    isSortable: true,
  },
];

const Component = () => {
  const [items, setItems] =
    useState<React.ComponentProps<typeof TreeView>['items']>(TREE_ITEMS);

  return (
    <TreeView
      items={items}
      onItemsChanged={(newItems, itemChangedReason) => {
        // eslint-disable-next-line no-restricted-syntax
        console.log('change with itemChangedReason:', itemChangedReason);
        setItems(newItems);
      }}
      TreeItemComponent={undefined}
    />
  );
};

export default Component;
